<template>
  <v-tab-item key="0">
    <slot></slot>
  </v-tab-item>
</template>

<script>
export default {
  name: 'PageTabPanel',
};
</script>
